<template>
    <section>
        <el-form inline>
            <el-form-item label="关键字">
                <el-input v-model="filters.keyword" placeholder="关键字" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="filters.enabled" multiple="">
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <!--工具条-->
        <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
        <!--列表-->
        
        <el-table-bar :fixed="true" :bottom="35">   
            <el-table :data="modules" highlight-current-row
            @current-change="selectCurrentRow"
            v-loading="listLoading" @selection-change="selsChange"
                    style="width: 100%;">
                <!-- <el-table-column type="selection" width="50">
                </el-table-column> -->
                <el-table-column type="index" width="80">
                </el-table-column>
                <el-table-column prop="code" label="编码" width="" sortable>
                </el-table-column>
                <el-table-column prop="customName" label="简称" width="" sortable>
                </el-table-column>
                <el-table-column prop="fullName" label="全称" width="" sortable>
                </el-table-column>
                <el-table-column prop="email" label="邮箱" width="" sortable>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" :formatter="formatCreateTime" width="" sortable>
                </el-table-column>
                <el-table-column prop="createBy" label="创建者" width="" sortable>
                </el-table-column>
                <el-table-column prop="type" label="类型" width="" sortable="">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.type==10?'info':'primary'" disable-transitions>{{scope.row.type==10?'客户':'服务商'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="enabled" label="状态" width="" sortable>
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.enabled  ? 'success' : 'danger'"
                                disable-transitions>{{scope.row.enabled ? "正常":"禁用"}}
                        </el-tag>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="操作" width="150">
                    <template scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" @click="handleDel(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
        </el-table-bar>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
            <el-pagination 
            layout="total, sizes, prev, pager, next" 
            @current-change="handleCurrentChange" 
            @size-change="handleSizeChange"
            :page-size="50"
            :page-sizes="[10, 20, 50, 100]"
            :total="total" style="float:right;">
            </el-pagination>
            <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="100"
                layout="total, sizes, prev, pager, next, jumper"
                :total="400">
            </el-pagination> -->
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
             <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                <el-form-item label="编码" prop="code">
                    <el-col :span="12">
                        <el-input v-model="editForm.code" auto-complete="off" disabled></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="简称" prop="customName">
                    <el-col :span="16">
                        <el-input v-model="editForm.customName" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="全称" prop="fullName">
                    <el-col :span="16">
                        <el-input v-model="editForm.fullName" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <!-- <el-form-item label="类型" prop="type">
                   <el-select v-model="editForm.type" placeholder="请选择类型">
                        <el-option v-for="item in typeList" :key="item.value" :label="item.text"
                                   :value="item.value"></el-option>

                    </el-select>
                </el-form-item> -->
                <el-form-item label="联系人" prop="contactPerson">
                    <el-col :span="12">
                        <el-input v-model="editForm.contactPerson" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="手机" prop="phoneNumber">
                    <el-col :span="12">
                        <el-input v-model="editForm.phoneNumber" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="电话" prop="telephoneNumber">
                    <el-col :span="12">
                        <el-input v-model="editForm.telephoneNumber" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-col :span="12">
                        <el-input v-model="editForm.email" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="营业执照号" prop="businessLicenseNo">
                    <el-col :span="12">
                        <el-input v-model="editForm.businessLicenseNo" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="税号" prop="taxNumber">
                    <el-col :span="12">
                        <el-input v-model="editForm.taxNumber" auto-complete="off"></el-input>
                    </el-col>                    
                </el-form-item>
                <el-form-item label="地址" prop="address">
                    <el-input v-model="editForm.address" auto-complete="off" type="textarea" autosize maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="editForm.remark" auto-complete="off" type="textarea" autosize maxlength="200" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="状态" prop="enabled">
                   <el-select v-model="editForm.enabled" placeholder="请选择状态">
                        <el-option v-for="item in statusList" :key="item.value" :label="item.text"
                                   :value="item.value"></el-option>

                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
                <el-form-item label="编码" prop="code">
                    <el-col :span="12">
                        <el-input v-model="addForm.code" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="简称" prop="customName">
                    <el-col :span="16">
                        <el-input v-model="addForm.customName" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="全称" prop="fullName">
                    <el-col :span="16">
                        <el-input v-model="addForm.fullName" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <!-- <el-form-item label="类型" prop="type" v-if="typeVisible">
                   <el-select v-model="addForm.type" placeholder="请选择类型">
                        <el-option v-for="item in typeList" :key="item.value" :label="item.text"
                                   :value="item.value"></el-option>

                    </el-select>
                </el-form-item> -->
                <el-form-item label="联系人" prop="contactPerson">
                    <el-col :span="12">
                        <el-input v-model="addForm.contactPerson" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="手机" prop="phoneNumber">
                    <el-col :span="12">
                        <el-input v-model="addForm.phoneNumber" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="电话" prop="telephoneNumber">
                    <el-col :span="12">
                        <el-input v-model="addForm.telephoneNumber" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-col :span="12">
                        <el-input v-model="addForm.email" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="营业执照号" prop="businessLicenseNo">
                    <el-col :span="12">
                        <el-input v-model="addForm.businessLicenseNo" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="税号" prop="taxNumber">
                    <el-col :span="12">
                        <el-input v-model="addForm.taxNumber" auto-complete="off"></el-input>
                    </el-col>                    
                </el-form-item>
                <el-form-item label="地址" prop="address">
                    <el-input v-model="addForm.address" auto-complete="off" type="textarea" autosize maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="addForm.remark" auto-complete="off" type="textarea" autosize maxlength="200" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="状态" prop="enabled">
                   <el-select v-model="addForm.enabled" placeholder="请选择状态">
                        <el-option v-for="item in statusList" :key="item.value" :label="item.text"
                                   :value="item.value"></el-option>

                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>

        <!-- 数据权限配置界面 -->
        <el-dialog title="数据权限分配" :visible.sync="assignFormVisible" v-model="assignFormVisible" :close-on-click-modal="false" width="70%">
            <el-card>
                <div slot="header" class="clearfix">
                    <div>
                        <h4>当前用户：{{currentRow?currentRow.email:''}}</h4>
                    </div>
                    <div class="buttons">
                        <el-button size="mini" @click="setAllChecked">全选</el-button>
                        <el-button size="mini" @click="resetChecked">清空</el-button>
                    </div>
                    
                </div>
                <el-tabs tab-position="right" @tab-click="clickAssignTab">
                    <el-tab-pane label="公司权限">
                        <el-form :v-model="assignForm">
                            <el-form-item label="" prop="organizationIds">
                                <el-checkbox-group v-model="assignForm.ids">
                                    <el-checkbox v-for="org in organizations" :key="org.id" 
                                    :label="org.id" :disabled="org.id==(currentRow!=null?currentRow.organizationId:0)" :title="org.fullName" style="width:330px;">
                                    <el-tag v-if="!org.enabled" type="danger" size="mini">已禁用</el-tag> 
                                    {{cutString(org.fullName,30)}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                        
                    </el-tab-pane>
                    <el-tab-pane label="仓库权限">
                        <el-form :v-model="warehouseAssignForm">
                            <el-form-item label="" prop="warehouseIds">
                                <el-checkbox-group v-model="warehouseAssignForm.ids">
                                    <el-checkbox v-for="ware in warehouses" :key="ware.warehouseId" :label="ware.warehouseId" :title="ware.warehouseName" style="width:330px;">
                                        <el-tag v-if="ware.status==1" type="danger" size="mini">已禁用</el-tag> 
                                        {{cutString(ware.warehouseName,30)}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
                
            </el-card>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="assignFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="assignSubmit" :loading="assignLoading">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import util from '../../../util/date'
    import { cutString } from "../../../util/validate"
    import {getOrganizationListPage, removeOrganization, editOrganization, addOrganization, addUserDataPermission,getWarehouseByOrg} from '../../api/api';
    import { getButtonList } from "../../promissionRouter";
    import Toolbar from "../../components/Toolbar";

    export default {
        components: { Toolbar },
        data() {
            return {
                buttonList: [],
                currentRow: null,
                tableHeight: 0,
                filters: {
                    keyword: '',
                    enabled: '',
                },
                modules: [],
                typeList: [{text: '客户', value: 10},{text: '服务商', value: 20}],
                typeVisible: false,
                statusList: [{text: '正常', value: true}, {text: '禁用', value: false}],
                total: 0,
                page: 1,
                pageSize: 50,
                listLoading: false,
                sels: [],//列表选中列
                organizations: [],
                currentOrganizationId: 0,
                currentUserOrganizations: [],
                warehouses: [],

                addDialogFormVisible: false,
                editFormVisible: false,//编辑界面是否显示
                editLoading: false,
                editFormRules: {

                    code: [
                        { required: true, message: '请输入编码', trigger: 'blur'},
                        { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
                    ],
                    customName: [
                        { required: true, message: '请输入简称', trigger: 'blur'},
                        { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                    ],
                    fullName: [
                        { required: true, message: '请输入全称', trigger: 'blur'},
                        { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                    ],
                    contactPerson: [
                        { required: true, message: '请输入联系人', trigger: 'blur'},
                        { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                    ],
                    phoneNumber: [
                        { required: true,pattern: /^1[345789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'},
                    ],
                    email: [
                        { required: true, message: '请输入邮箱', trigger: 'blur'},
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur','change'] },

                    ],
                    businessLicenseNo: [
                        { max: 50, message: '最多50个字符', trigger: 'blur'}
                    ],
                    taxNumber: [
                        { max: 50, message: '最多50个字符', trigger: 'blur'}
                    ],
                    telephoneNumber: [
                        { max: 50, message: '最多50个字符', trigger: 'blur'}
                    ]
                },
                //编辑界面数据
                editForm: {
                    id: 0,
                    createBy: '',
                    code: '',
                    customName: '',
                    fullName: '',
                    contactPerson: '',
                    phoneNumber: '',
                    telephoneNumber: '',
                    email: '',
                    businessLicenseNo: '',
                    taxNumber: '',
                    address: '',
                    remark: '',
                    type: 10,
                    enabled: false,
                },

                addFormVisible: false,//新增界面是否显示
                addLoading: false,
                addFormRules: {

                    code: [
                        { required: true, message: '请输入编码', trigger: 'blur'},
                        { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
                    ],
                    customName: [
                        { required: true, message: '请输入简称', trigger: 'blur'},
                        { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                    ],
                    fullName: [
                        { required: true, message: '请输入全称', trigger: 'blur'},
                        { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                    ],
                    contactPerson: [
                        { required: true, message: '请输入联系人', trigger: 'blur'},
                        { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                    ],
                    phoneNumber: [
                        { required: true,pattern: /^1[345789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'},
                    ],
                    email: [
                        { required: true, message: '请输入邮箱', trigger: 'blur'},
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur','change'] },

                    ],
                    businessLicenseNo: [
                        { max: 50, message: '最多50个字符', trigger: 'blur'}
                    ],
                    taxNumber: [
                        { max: 50, message: '最多50个字符', trigger: 'blur'}
                    ],
                    telephoneNumber: [
                        { max: 50, message: '最多50个字符', trigger: 'blur'}
                    ]
                },
                //新增界面数据
                addForm: {
                    id: 0,
                    createBy: '',
                    code: '',
                    customName: '',
                    fullName: '',
                    contactPerson: '',
                    phoneNumber: '',
                    telephoneNumber: '',
                    email: '',
                    businessLicenseNo: '',
                    taxNumber: '',
                    address: '',
                    remark: '',
                    type: 10,
                    enabled: false,
                },
                assignFormVisible: false,
                assignLoading: false,
                assignForm: {
                    assignType: 0,
                    ids: [],
                    userId: 0
                },
                warehouseAssignForm: {
                    assignType: 1,
                    ids: [],
                    userId: 0
                },
                tabIndex: '1'
            }
        },
        methods: {
            clickAssignTab(tab, event){
                this.tabIndex = tab.index;
            },
            cutString: function(str, len) {
                return cutString(str, len);
            },
            selectCurrentRow(val) {
                this.currentRow = val;
            },
            callFunction(item) {
            // this.filters = {
            //     keyword: item.search
            // };
            this[item.func].apply(this, item);
            },
            formatCreateTime: function (row, column) {
                return (!row.createTime || row.createTime == '') ? '' : util.formatDate.format(new Date(row.createTime), 'yyyy-MM-dd');
            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.getOrganizations();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getOrganizations();
            },
            //获取接口列表
            getOrganizations() {
                let para = {
                    page: this.page,
                    pageSize: this.pageSize,
                    key: this.filters.keyword,
                    enabled: this.filters.enabled.toString()
                };
                this.listLoading = true;
                console.info(para);
                //NProgress.start();
                getOrganizationListPage(para).then((res) => {
                    this.total = res.data.response.total;
                    this.modules = res.data.response.pageData;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            //删除
            handleDel(index, row) {
                
                if (!row) {
                    this.$message({
                    message: "请选择要删除的一行数据！",
                    type: "error"
                    });

                    return;
                }
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    //NProgress.start();
                    let para = {id: row.Id};
                    removeOrganization(para).then((res) => {

                        if (util.isEmt.format(res)) {
                            this.listLoading = false;
                            return;
                        }
                        this.listLoading = false;
                        //NProgress.done();
                        if (res.data.success) {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });

                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: 'error'
                            });
                        }

                        this.getOrganizations();
                    });
                }).catch(() => {

                });
            },
            handleEnable() {
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要启用的一行数据！",
                        type: "error"
                    });

                    return;
                }
                if (row.enabled){
                    this.$message({
                        message: "当前数据为启用状态，无需启用！",
                        type: "success"
                    });

                    return;
                }
                row.enabled = true;
                let para = Object.assign({}, row);
                editOrganization(para).then((res) => {

                    if (res.data.success) {
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                        this.getOrganizations();
                    } else {
                        row.enabled = false;
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }
                });
            },
            handleStop() {
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要禁用的一行数据！",
                        type: "error"
                    });

                    return;
                }
                if (!row.enabled){
                    this.$message({
                        message: "当前数据为禁用状态，无需禁用！",
                        type: "success"
                    });

                    return;
                }
                row.enabled = false;
                let para = Object.assign({}, row);
                editOrganization(para).then((res) => {

                    if (res.data.success) {
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                        this.getOrganizations();
                    } else {
                        row.enabled = true;
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }
                });
            },
            //显示编辑界面
            handleEdit() {
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                    message: "请选择要编辑的一行数据！",
                    type: "error"
                    });

                    return;
                }
                
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
            },
            //显示新增界面
            handleAdd() {
                this.addFormVisible = true;
            },
            handleAssign() {
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                    message: "请选择要操作的一行数据！",
                    type: "error"
                    });

                    return;
                }
                this.assignFormVisible = true;
                this.assignForm.userId = row.userId;
                this.warehouseAssignForm.userId = row.userId;
                this.assignForm.ids = row.organizationIds;
                this.warehouseAssignForm.ids = row.warehouseIds;
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.editForm);

                            editOrganization(para).then((res) => {

                                if (util.isEmt.format(res)) {
                                    this.editLoading = false;
                                    return;
                                }
                                if (res.data.success) {
                                    this.editLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'success'
                                    });
                                    this.$refs['editForm'].resetFields();
                                    this.editFormVisible = false;
                                    this.getOrganizations();
                                } else {
                                    this.editLoading = false;
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'error'
                                    });

                                }
                            });
                        });
                    }
                });
            },
            //新增
            addSubmit: function () {
                let _this = this;
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.addForm);

                            
                            para.createTime = util.formatDate.format(new Date(), 'yyyy-MM-dd');
                            para.modifyTime = para.createTime;
                            para.isDeleted = false;

                            var user = JSON.parse(window.localStorage.user);

                            if (user && user.id > 0) {
                                console.info(user);
                                para.createId = user.id;
                                para.createBy = user.realName;
                                para.parentId = user.organizationId;
                            } else {
                                this.$message({
                                    message: '用户信息为空，先登录',
                                    type: 'error'
                                });
                                _this.$router.replace(_this.$route.query.redirect ? _this.$route.query.redirect : "/");
                            }
                            
                            addOrganization(para).then((res) => {

                                if (util.isEmt.format(res)) {
                                    this.addLoading = false;
                                    return;
                                }

                                if (res.data.success) {
                                    this.addLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'success'
                                    });
                                    this.$refs['addForm'].resetFields();
                                    this.addFormVisible = false;
                                    this.getOrganizations();
                                }
                                else {
                                    this.addLoading = false;
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'error'
                                    });

                                }

                            });

                        });
                    }
                });
            },
             assignSubmit: function() {
                this.assignLoading = true;
                let para = {};
                if (this.tabIndex==='0'){
                    para = Object.assign({}, this.assignForm);
                }else{
                    para = Object.assign({}, this.warehouseAssignForm);
                }
                addUserDataPermission(para).then((res)=>{
                    
                    if (util.isEmt.format(res))
                    {
                        this.assignLoading = false;
                        return;
                    }
                    if(res.data.success){
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                        this.assignLoading = false;
                        this.assignForm.ids = [];
                        this.warehouseAssignForm.ids = [];
                        this.assignForm.userId = 0;
                        this.assignFormVisible = false;
                        this.getOrganizations();
                    }else{
                        this.assignLoading = false;
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }
                });

            },
            selsChange: function (sels) {
                this.sels = sels;
            },
            setAllChecked: function() {
                var _this = this
                let ids = [];
                if(_this.tabIndex==='0'){
                    for(var i=0;i<_this.organizations.length;i++){
                        ids.push(_this.organizations[i].id);
                    }
                    _this.assignForm.ids = ids;
                }else{
                    for(var i=0;i<_this.warehouses.length;i++){
                        ids.push(_this.warehouses[i].warehouseId);
                    }
                    _this.warehouseAssignForm.ids = ids;
                }
            },
            resetChecked: function() {
                var _this = this
                let ids = [];
                if(_this.tabIndex==='0'){
                    ids.push(this.currentOrganizationId);
                    _this.assignForm.ids = ids;
                }else{
                    _this.warehouseAssignForm.ids = ids;
                }
            }
        },
        mounted() {
            this.getOrganizations();
            getOrganizationListPage({pageSize:100,key:'',includeSelf: false}).then((res)=>{
                this.organizations = res.data.response.pageData;
            });
            
            let user = JSON.parse(window.localStorage.user);
            this.currentOrganizationId = user.organizationId;
            this.currentUserOrganizations = user.organizationList;
            getWarehouseByOrg({ orgId: user.organizationId }).then((res)=>{
                this.warehouses = res.data.response.wareHouse;
            });

            let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
            this.buttonList = getButtonList(this.$route.path, routers);
        }
    }

</script>

<style scoped>

</style>
